import type * as React from 'react';

type ContentContainerType = {
  overflowHidden?: boolean;
  startFirstColumn?: boolean;
};

export const ContentContainer: React.FunctionComponent<
  ContentContainerType
> = ({ children, overflowHidden, startFirstColumn }) => {
  return (
    <div
      role='presentation'
      className={`row-start-3 row-end-4 col-end-3 sm:col-end-3 sm:row-start-2 sm:row-end-3 ${
        overflowHidden ? 'overflow-hidden' : ''
      } ${startFirstColumn ? 'col-start-1' : 'col-start-2'} mt-2`}
    >
      {children}
    </div>
  );
};
